import HandleLetters from './HandleLetters.jsx';
export {
  HandleLetters
};


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/list-handle-letters/index.js